import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bb53db5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "case-data" }
const _hoisted_2 = { class: "row-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "row-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsDropdown = _resolveComponent("AsDropdown")!
  const _component_AsBlock = _resolveComponent("AsBlock")!
  const _component_CasePersonalData = _resolveComponent("CasePersonalData")!
  const _component_AsEditBlock = _resolveComponent("AsEditBlock")!
  const _component_CaseResponsibility = _resolveComponent("CaseResponsibility")!
  const _component_CaseClinicalInformation = _resolveComponent("CaseClinicalInformation")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AsBlock, { class: "row-wrapper-space-between" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", null, _hoisted_4)), [
            [_directive_tooltip, _ctx.$t('case.rights.title')]
          ]),
          _createElementVNode("div", null, _toDisplayString(_ctx.caseUsersWithRights?.length ? _ctx.caseUsersWithRights : _ctx.pc.emptyValue), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_AsDropdown, {
            value: _ctx.selectedChangeDate,
            options: _ctx.caseChanges,
            optionLabel: (value) => _ctx.getChangesDateLabel(value),
            disabled: _ctx.personalDataEditParams.isEditing,
            onUpdate: _cache[0] || (_cache[0] = (value) => ((_ctx.selectedChangeDate = value), _ctx.loadSpecificCaseState()))
          }, null, 8, ["value", "options", "optionLabel", "disabled"])
        ])
      ]),
      _: 1
    }),
    (_ctx.canRead(_ctx.caseScope.CasePersonalData))
      ? (_openBlock(), _createBlock(_component_AsEditBlock, {
          key: 0,
          header: _ctx.$t('case.personalData.Title'),
          isReadOnly: 
        _ctx.isSpecificCaseStateSelected ||
        !_ctx.canWrite(_ctx.caseScope.CasePersonalData, _ctx.currentCase.createdBy, _ctx.currentCase.created, _ctx.currentCase.modified) ||
        _ctx.currentCase.caseData.isDeleted
      ,
          editParams: _ctx.personalDataEditParams,
          isDisabled: !_ctx.isPersonalDataValid,
          onEditModeEnabled: _ctx.processEditPersonalDataEnable,
          onEditModeSubmit: _ctx.processEditPersonalDataSubmit,
          onEditModeCanceled: _ctx.processEditPersonalDataCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CasePersonalData, {
              personalData: _ctx.personalData,
              caseNumber: _ctx.currentCase?.caseData?.caseNumber,
              isEditMode: true,
              isEditing: _ctx.personalDataEditParams.isEditing
            }, null, 8, ["personalData", "caseNumber", "isEditing"])
          ]),
          _: 1
        }, 8, ["header", "isReadOnly", "editParams", "isDisabled", "onEditModeEnabled", "onEditModeSubmit", "onEditModeCanceled"]))
      : _createCommentVNode("", true),
    (_ctx.canRead(_ctx.caseScope.CaseData))
      ? (_openBlock(), _createBlock(_component_AsEditBlock, {
          key: 1,
          class: _normalizeClass({
        stripped: !_ctx.caseResponsibilityParams.isEditing,
      }),
          header: _ctx.$t('case.responsibility.Title'),
          isReadOnly: 
        _ctx.isSpecificCaseStateSelected ||
        !_ctx.canWrite(_ctx.caseScope.CaseData, _ctx.currentCase.createdBy, _ctx.currentCase.created, _ctx.currentCase.modified) ||
        _ctx.currentCase.caseData.isDeleted
      ,
          editParams: _ctx.caseResponsibilityParams,
          onEditModeEnabled: _ctx.processEditResponsibilityEnable,
          onEditModeSubmit: _ctx.processEditResponsibilitySubmit,
          onEditModeCanceled: _ctx.processEditResponsibilityCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CaseResponsibility, {
              responsibility: _ctx.caseResponsibility,
              isEditMode: true,
              isEditing: _ctx.caseResponsibilityParams.isEditing
            }, null, 8, ["responsibility", "isEditing"])
          ]),
          _: 1
        }, 8, ["class", "header", "isReadOnly", "editParams", "onEditModeEnabled", "onEditModeSubmit", "onEditModeCanceled"]))
      : _createCommentVNode("", true),
    (_ctx.canRead(_ctx.caseScope.CaseData))
      ? (_openBlock(), _createBlock(_component_AsEditBlock, {
          key: 2,
          header: _ctx.$t('case.clinicalInformation.Title'),
          editParams: _ctx.clinicalInformationParams,
          isReadOnly: 
        _ctx.isSpecificCaseStateSelected ||
        !_ctx.canWrite(_ctx.caseScope.CaseData, _ctx.currentCase.createdBy, _ctx.currentCase.created, _ctx.currentCase.modified) ||
        _ctx.currentCase.caseData.isDeleted
      ,
          onEditModeEnabled: _ctx.processClinicalInformationEnable,
          onEditModeSubmit: _ctx.processClinicalInformationSubmit,
          onEditModeCanceled: _ctx.processClinicalInformationCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CaseClinicalInformation, {
              model: _ctx.caseClinicalInformation,
              isEditMode: true,
              isEditing: _ctx.clinicalInformationParams.isEditing
            }, null, 8, ["model", "isEditing"])
          ]),
          _: 1
        }, 8, ["header", "editParams", "isReadOnly", "onEditModeEnabled", "onEditModeSubmit", "onEditModeCanceled"]))
      : _createCommentVNode("", true)
  ]))
}